import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import {
  GET_CLIENT_BANKS,
  POST_TRANSACTION,
  CLIENT_OTP_URL,
  VERIFY_OTP_URL,
  GET_WITHDRAWAL_AMOUNT,
} from "../services/Apis";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

const Withdrawcreate = () => {
  const location = useLocation();
  const stateFromLink = location.state;
  const [SidebarState, setSidebarState] = useState(false);
  const [loading, setLoading] = useState(true);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [attachment, setAttachment] = useState("");
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [amtValidation, setAmtValidation] = useState("");
  const [refValidation, setRefValidation] = useState("");
  const [amount, setAmount] = useState(0);
  const [minAmount, setminAmount] = useState(500);
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const navigate = useNavigate();
  const [withdrawableAmt, setwithdrawableAmt] = useState(0);
  const [usedMargin, setusedMargin] = useState(0);
  const [previousDeposits, setpreviousDeposits] = useState(0);
  const [previousWithdrawals, setpreviousWithdrawals] = useState(0);


  useEffect(() => {
    setwithdrawableAmt(encStorage.getItem("withdrawable_amount"));
    setAmount(encStorage.getItem("withdrawable_amount"));
    setusedMargin(encStorage.getItem("used_margin"));
    setpreviousDeposits(encStorage.getItem("previous_deposits"));
    setpreviousWithdrawals(encStorage.getItem("previous_withdrawals"));
    //console.log("withdrawableAmt", withdrawableAmt);
  }, []);

  // const fetchWithdrawals = async () => {
  //   const token = encStorage.getItem("token");
  //   //console.log(token);
  //   try {
  //     const response = await axios.get(GET_WITHDRAWAL_AMOUNT, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //   } catch (error) {
  //     console.error("Error fetching Withdrawal Amount:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   fetchWithdrawals();
  // }, []);
  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const handleOtpSubmit = async (promptVal) => {
    const token = encStorage.getItem("token");
    try {
      const formData = new FormData();
      formData.append("otp", promptVal);
      const response = await axios.post(VERIFY_OTP_URL, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.message === "OTP verified successfully") {
        setOtpVerified(true);
        handleSubmit();
      } else {
        alert("OTP not verified");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      alert("OTP is not verified.");
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setAmount(value);
    if (previousDeposits === 0 && usedMargin > 0) {
      setAmtValidation("Please refer to Credit Offer T&C point no. 4, At the time of a withdrawal request, all open positions must be closed (NIL or 0).");
      return;
    } else if (previousDeposits === 0 && (previousWithdrawals >= 1000 || (parseFloat(previousWithdrawals) + parseFloat(value)) > 1000)) {
      setAmtValidation("Please refer to Credit Offer T&C point no. 3, The maximum withdrawal limit* using the Credit Offer is ₹1,000.");
      return;
    } else if (value < minAmount) {
      setAmtValidation("Minimum Amount for Withdrawal should be " + minAmount);
    } else if (value > withdrawableAmt) {
      setAmtValidation(
        "Maximum Amount available for Withdrawal is " + withdrawableAmt
      );
    } else {
      setAmtValidation("");
    }
  };

  const handleBankSelect = (bankId) => {
    setSelectedBank(bankId);
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (previousDeposits === 0 && usedMargin > 0) {
      setAmtValidation("Please refer to Credit Offer T&C point no. 4, At the time of a withdrawal request, all open positions must be closed (NIL or 0).");
      return;
    } else if (previousDeposits === 0 && (previousWithdrawals >= 1000 || (parseFloat(previousWithdrawals) + parseFloat(amount)) > 1000)) {
      setAmtValidation("Please refer to Credit Offer T&C point no. 3, The maximum withdrawal limit* using the Credit Offer is ₹1,000.");
      return;
    } else {
      setAmtValidation("");
    }
    if (!selectedBank) {
      //alert("Please select a bank.");
      return;
    }
    if (amtValidation !== "") {
      //alert("Please fix the amount validation errors.");
      return;
    }
    const token = encStorage.getItem("token");
    if (!otpVerified) {
      try {
        await axios.post(
          CLIENT_OTP_URL,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const promptVal = prompt("Enter OTP:");
        setOtp(promptVal);
        handleOtpSubmit(promptVal);
      } catch (error) {
        console.error("Error requesting OTP:", error);
        alert("Error requesting OTP");
      }
      return;
    }
  };
  const handleSubmit = async (e) => {
    const token = encStorage.getItem("token");
    const formData = new FormData();
    formData.append("amount", amount);
    if (amount < minAmount) {
      setAmtValidation("Minimum Amount for Credit should be " + minAmount);
      return false;
    }
    formData.append("bank_detail_id", selectedBank);
    formData.append("transaction_type", 1);

    try {
      await axios.post(POST_TRANSACTION, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      navigate("/withdrawals", {
        state: { message: "Withdrawal created successfully!", status: 200 },
      });
    } catch (error) {
      navigate("/withdrawals", {
        state: { message: "Error during Withdrawal!" + error, status: 400 },
      });
    }
  };

  const fetchBanks = async () => {
    const token = encStorage.getItem("token");
    try {
      const response = await axios.get(GET_CLIENT_BANKS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setBanks(response.data.banks);
    } catch (error) {
      console.error("Error fetching Withdrawals:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBanks();
  }, []);

  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <main>
            <div className="container-fluid px-4">
              <div className="d-flex">
                <h3 className="mt-4 w-75">Add Withdrawal</h3>
                <div className="mt-auto me-0 mb-2 w-25 d-flex justify-content-end">
                  <Link
                    to="/withdrawals"
                    className="btn btn-primary"
                    title="New"
                  >
                    <span className="d-md-inline">Back</span>
                  </Link>
                </div>
              </div>
              <div className="card mb-4">
                <div className="card-body">
                  <form
                    id="withdrawform"
                    method="POST"
                    encType="multipart/form-data"
                    onSubmit={handleFormSubmit}
                  >
                    <div className="row">
                      <div className="form-group col-sm-6">
                        <label>Amount</label>
                        <div className="input-group">
                          <select className="form-control" value="113" readOnly>
                            <option value="113">₹</option>
                          </select>
                          <input
                            type="number"
                            className="form-control w-75"
                            id="amount"
                            placeholder="Enter Amount"
                            value={amount}
                            onChange={handleAmountChange}
                            required
                          />
                        </div>
                        <p id="amtValidation" className="text-danger fs-6">
                          {amtValidation}
                        </p>
                      </div>
                      <div className="form-group col-sm-6">
                        <label htmlFor="bank_detail_id">Bank</label>
                        <select
                          className="form-control"
                          id="bank_detail_id"
                          value={selectedBank}
                          onChange={(e) => handleBankSelect(e.target.value)}
                          required
                        >
                          <option value="">Select Bank</option>
                          {banks.map((bank) => (
                            <option key={bank.id} value={bank.id}>
                              {bank.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary mt-5"
                      disabled={amtValidation !== "" || !selectedBank}
                    >
                      Submit
                    </button>
                  </form>
                  <div className="row">
                    <div className="col-sm-2">&nbsp;</div>
                    <div className="col-sm-8">
                      <table
                        border="1"
                        className="table table-bordered table-striped w-100 align-middle"
                      >
                        <thead>
                          <tr>
                            <th colSpan={2}>Please note: Withdrawal Timings</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th>Monday - Friday</th>
                            <td>10:00 AM - 11:30 PM</td>
                          </tr>
                          <tr>
                            <th>Saturday</th>
                            <td>10:00 AM - 03:00 PM</td>
                          </tr>
                          <tr>
                            <th>Sunday</th>
                            <td>OFF</td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              Withdrawal requests submitted beyond the specified
                              time will be processed on the next working day.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-sm-2">&nbsp;</div>
                  </div>
                  {/* <div className="row mt-3">
                    <div className="col-sm-2">&nbsp;</div>
                    <div className="col-sm-8">
                      <h2 className="text-center mb-3 text-primary">
                        Credit Offer Terms & Conditions
                      </h2>
                      <table
                        border="1"
                        className="table table-bordered table-striped w-100 align-middle"
                      >
                        <thead>
                          <tr>
                            <th colSpan={2}>Credit Offer Terms & Conditions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1.</td>
                            <td>
                              Each user is permitted to operate <b>only one account</b>. Multiple
                              accounts under the same user are strictly prohibited.
                            </td>
                          </tr>
                          <tr>
                            <td>2.</td>
                            <td>
                              Users found with multiple accounts will face{" "}
                              <b>permanent termination</b>, and all associated accounts will be
                              blocked immediately.
                            </td>
                          </tr>
                          <tr>
                            <td>3.</td>
                            <td>
                              The <b>maximum withdrawal limit</b> using the Credit Offer is{" "}
                              <b>₹1,000</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>4.</td>
                            <td>
                              At the time of a <b>withdrawal request, all open positions must be closed (NIL or 0)</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>5.</td>
                            <td>
                              Any remaining profit earned from this credit will be{" "}
                              <b>flushed out</b> once the client has reached the{" "}
                              <b>maximum withdrawal limit</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>6.</td>
                            <td>
                              The <b>₹1,000 credit</b> will remain active until it is fully
                              utilized or settled through liquidation.
                            </td>
                          </tr>
                          <tr>
                            <td>7.</td>
                            <td>
                              If a client <b>makes a deposit before submitting a withdrawal request</b>, all{" "}
                              <b>profits made before the deposit will be flushed out</b>. However, the{" "}
                              <b>₹1,000 credit</b> will remain as per the allowed withdrawal limit.
                            </td>
                          </tr>
                          <tr>
                            <td>8.</td>
                            <td>
                              After utilizing the <b>maximum withdrawal offer</b>, clients may deposit funds and continue trading with{" "}
                              <b>no restrictions on further deposits or withdrawals</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>9.</td>
                            <td>
                              Clients <b>must make a deposit before trading</b>. Any{" "}
                              <b>profits generated using the credit before making a deposit</b> will not be considered valid.
                            </td>
                          </tr>
                          <tr>
                            <td>10.</td>
                            <td>
                              If a client incurs <b>losses after making a deposit</b>, the available{" "}
                              <b>credit will be adjusted against the loss instantly</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>11.</td>
                            <td>
                              Credits are <b>non-transferable</b> and cannot be{" "}
                              <b>exchanged for cash or transferred between accounts</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>12.</td>
                            <td>
                              If an account exhibits <b>suspicious behavior</b> or is suspected of{" "}
                              <b>fraudulent activity</b>, the company reserves the right to{" "}
                              <b>terminate the account without prior notice</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>13.</td>
                            <td>
                              The company may impose additional <b>restrictions based on location and trading patterns</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>14.</td>
                            <td>
                              Any attempt to <b>manipulate, abuse, or exploit</b> the credit system—including the use of{" "}
                              <b>bots, arbitrage, or other unfair means</b>—will result in{" "}
                              <b>immediate disqualification and account suspension</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>15.</td>
                            <td>
                              The company reserves the right to <b>modify or terminate this credit offer</b> at any time{" "}
                              <b>without prior notice</b>.
                            </td>
                          </tr>
                          <tr>
                            <td>16.</td>
                            <td>
                              This offer is available for a <b>limited time period</b> and may be withdrawn or modified at the company’s discretion.
                            </td>
                          </tr>
                          <tr>
                            <td>17.</td>
                            <td>
                              By using this credit, users <b>agree to these terms</b> and acknowledge that any{" "}
                              <b>violation may lead to loss of eligibility and permanent account closure</b>.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-sm-2">&nbsp;</div>
                  </div> */}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Withdrawcreate;
